import type { ReactElement, VoidFunctionComponent } from 'react';

import { useToggle } from '../../../hooks';
import Button from '../Button';
import Markdown from '../Markdown';

import './CollapsibleTextBlock.less';

type Props = {
  text: string;
  maxLength?: number;
  useMarkdown?: boolean;
};

/**
 * CollapsibleTextBlock truncates text longer than maxLength and controls the
 * amount of visible text via "Show all" and "Show less" buttons. If the text
 * is less than maxLength, then no buttons are shown.
 */
const CollapsibleTextBlock: VoidFunctionComponent<Props> = ({ text, maxLength = 200, useMarkdown = false }) => {
  const [isShowingAll, onToggle] = useToggle(false);
  const isTextShort = text.length <= maxLength;

  let displayText: string | ReactElement = isTextShort || isShowingAll
    ? text
    : `${text.substring(0, maxLength)}...`;

  if (useMarkdown) {
    displayText = <Markdown text={displayText} />;
  }

  return (
    <div className="fossa-showhidetext">
      {displayText}
      {isTextShort ? null : (
        <Button type="text" size="medium" onClick={onToggle}>
          {isShowingAll ? 'Show less' : 'Show all'}
        </Button>
      )}
    </div>
  );
};

export default CollapsibleTextBlock;
